import { Outlet } from "react-router";
import Header from "../../../../../component/layout/header";
import useNav from "../../../../../script/tabingNavArray";

const UsersLayout = () => {
  const navList = useNav();
  let { usersBottomHeader, OperationsTopHeader } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={usersBottomHeader} topTabs={OperationsTopHeader} />
      <Outlet />
    </div>
  );
};

export default UsersLayout;
